import { Configuration, PopupRequest } from "@azure/msal-browser";

// Configuração do Microsoft Authentication Library (MSAL)
export const msalConfig: Configuration = {
    auth: {
        clientId: "9df1d92a-709a-4297-bcb0-49553e36f7df", // Client ID obtido do Azure AD (App: PAGAR_DASHBOARD)
        authority: "https://login.microsoftonline.com/e2d62140-be09-4eb0-98a4-b31d13d73626", // Tenant ID da organização
        redirectUri: window.location.origin, // URL de redirecionamento (ex: http://localhost:8080)
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage", // Armazenar estado na sessão
        storeAuthStateInCookie: false,
    },
};

// Escopos para solicitação de login
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "email", "profile"],
};

// Mapeamento de domínios para roles
export const ADMIN_DOMAIN = "@pagar.com.br";

// Trigger build
